import { IDropZoneWorkflowState } from 'interfaces/designOrchestration/designOrchestrationState.interface';
import { Useuid } from 'utils/hooks/useUid';
import style from './DesignOrchestrationDiagram.module.scss';
import {
  IDropZoneStepGroup,
  IOrchestrationNodeDropZone,
} from 'interfaces/designOrchestration/designOrchestrationDiagram.interface';
import { FlowNode } from './DesignOrchestrationDiagram';

export enum DEFAULT_NODES_IDS {
  GLOBAL_FAILBACK_STEPS = '3',
  INITIAL_DROPZONE = '2',
  INITIAL_FAILBACK_DROPZONE = '4',
  LEGEND_NODE = '5',
  ORCHESTRATION_STEPS = '1',
}

export enum DROPZONE_TYPES {
  GLOBAL_FAILBACK_STEPS = '5',
  NESTED = '2',
  NESTED_FAILBACK = '3',
  NESTED_GLOBAL_FAILBACK = '10',
  PARALLEL = '4',
  PARALLEL_FAILBACK = '7',
  PARALLEL_GLOBAL_FAILBACK = '9',
  PREDECESSOR = '0',
  PREDECESSOR_FAILBACK = '8',
  SUCCEDING = '1',
  SUCCEDING_FAILBACK = '6',
  SUCCEDING_GLOBAL_FAILBACK = '11',
}

export enum DROPZONES_NAMES {
  FAILBACK = 'Failback',
  GLOBAL_FAILBACK_STEPS = 'Global Failback Steps',
  NESTED = 'Nested',
  PARALLEL = 'Parallel',
  PARALLEL_FAILBACK = 'Parallel Failback',
  PARALLEL_GLOBAL_FAILBACK = 'Parallel Global Failback',
  PREDECESSOR = 'Predecessor',
  PREDECESSOR_FAILBACK = 'Predecessor Failback',
  SUCCEDING = 'Succeeding',
  SUCCEDING_FAILBACK = 'Succeeding Failback',
}

export const DEFAULT_NODES: IOrchestrationNodeDropZone[] = [
  {
    data: {
      label: 'Orchestration Steps:',
      stepType: 'label',
    },
    id: DEFAULT_NODES_IDS.ORCHESTRATION_STEPS,
    position: { x: 20, y: 20 },
    type: 'headerNode',
  },
  {
    data: {
      dropzoneType: DROPZONE_TYPES.SUCCEDING,
      id: '2',
      stepType: 'step',
      tooltip:
        'Drag and drop your module here to add a step to your orchestration',
    },
    id: DEFAULT_NODES_IDS.INITIAL_DROPZONE,
    position: { x: 150, y: 60 },
    type: 'dropZoneNode',
  },

  {
    data: {
      label: 'Orchestration Global Failback Steps:',
      stepType: 'label',
    },
    id: DEFAULT_NODES_IDS.GLOBAL_FAILBACK_STEPS,
    position: { x: 20, y: 150 },
    type: 'headerNode',
  },
  {
    data: {
      dropzoneType: DROPZONE_TYPES.GLOBAL_FAILBACK_STEPS,
      id: '4',
      stepType: 'globalFailback',
      tooltip:
        "Drag and drop your failback module here. Modules in the 'Global failback drop zone' will be executed if the orchestration fails",
    },
    id: DEFAULT_NODES_IDS.INITIAL_FAILBACK_DROPZONE,
    position: { x: 150, y: 200 },
    type: 'dropZoneNode',
  },
  {
    className: style['node-transition'],
    data: {
      label: 'Orchestration Global Failback Steps:',
      stepType: 'label',
    },
    id: DEFAULT_NODES_IDS.LEGEND_NODE,
    position: { x: 2000, y: 20 },
    type: 'legendNode',
  },
];

export const MINIMUM_CANVAS_SIZE_NO_NODES = 700;
export const MINIMUM_CANVAS_SIZE = 1040;

export const NEW_MODULE: IDropZoneStepGroup = {
  nextStepGroup: null,
  parentWorkflowStepGroupId: null,
  steps: [
    {
      module: {
        id: null,
        name: '',
        description: '',
        textId: '',
        parameters: [],
        version: '',
      },
      failbackStepGroup: null,
      nestedStepGroup: null,
      paramGroups: [],
      stepId: Useuid(),
      stepIndex: null,
      workflowStepGroupId: null,
      stepTitle: null,
      workflowStepId: Math.floor(Math.random() * 1000000),
    },
  ],
  workflowStepGroupId: null,
};

export const WORKFLOW_INITIAL_OBJECT: IDropZoneWorkflowState = {
  steps: [],
  workflow: {
    failbackStepGroup: {
      nextStepGroup: null,
      parentWorkflowStepGroupId: null,
      steps: [
        {
          stepCondition: null,
          stepId: DROPZONE_TYPES.GLOBAL_FAILBACK_STEPS,
          module: {
            id: null,
            textId: '',
            name: '',
            version: '',
            description: '',
            parameters: [],
          },
          workflowStepGroupId: null,
          nestedStepGroup: null,
          workflowStepId: DEFAULT_NODES_IDS.INITIAL_FAILBACK_DROPZONE,
          failbackStepGroup: null,
          stepTitle: DROPZONES_NAMES.GLOBAL_FAILBACK_STEPS,
          paramGroups: [],
          stepIndex: null,
        },
      ],
      workflowStepGroupId: -2,
    },
    name: '',
    nextStepGroup: {
      nextStepGroup: null,
      parentWorkflowStepGroupId: null,
      steps: [
        {
          stepCondition: null,
          module: {
            id: null,
            textId: '',
            name: '',
            version: '',
            description: '',
            parameters: [],
          },
          stepId: DROPZONE_TYPES.SUCCEDING,
          nestedStepGroup: null,
          workflowStepGroupId: null,
          failbackStepGroup: null,
          workflowStepId: DEFAULT_NODES_IDS.INITIAL_DROPZONE,
          paramGroups: [],
          stepTitle: DROPZONES_NAMES.SUCCEDING,
          stepIndex: null,
        },
      ],
      workflowStepGroupId: -1,
    },
  },
};

export const WORKFLOW_MOCK_FROM_BASIC_MODULE: IDropZoneWorkflowState = {
  steps: [
    {
      endTime: '',
      executionNumber: 0,
      ec2Instance: null,
      jobId: -1,
      jobStepId: -1,
      jobStepParams: [],
      sqsQueueName: '',
      startTime: '',
      status: '',
      submitTime: '',
      workflowStepId: DEFAULT_NODES_IDS.INITIAL_DROPZONE,
    },
  ],
  workflow: {
    failbackStepGroup: null,
    name: '',
    nextStepGroup: {
      nextStepGroup: {
        nextStepGroup: {
          parentWorkflowStepGroupId: null,
          nextStepGroup: null,
          workflowStepGroupId: null,
          steps: [
            {
              workflowStepGroupId: null,
              workflowStepId: 1744741560157,
              stepId: DROPZONE_TYPES.SUCCEDING,
              stepTitle: 'Succeeding',
              module: {
                id: null,
                textId: '',
                version: '',
                name: '',
                description: '',
                parameters: [],
              },
              stepIndex: null,
              nestedStepGroup: null,
              paramGroups: [],
              associatedMainNodeId: 1744741562483,
              failbackStepGroup: null,
              nestGroupId: ['1744741562483'],
            },
          ],
        },
        parentWorkflowStepGroupId: null,
        steps: [
          {
            stepId: '1iotb6lv0096c8f63a39a0f',
            workflowStepGroupId: null,
            module: {
              id: 302,
              textId: 'system-aggregator',
              version: '',
              name: 'System Aggregator',
              description: 'Aggregate batches.',
              parameters: [],
            },
            workflowStepId: 1744741562483,
            nestedStepGroup: null,
            stepTitle: 'System Aggregator',
            failbackStepGroup: {
              parentWorkflowStepGroupId: null,
              workflowStepGroupId: null,
              nextStepGroup: null,
              steps: [
                {
                  workflowStepId: 1744741562510,
                  workflowStepGroupId: null,
                  stepTitle: 'Failback',
                  stepId: DROPZONE_TYPES.NESTED_FAILBACK,
                  stepIndex: null,
                  module: {
                    id: null,
                    textId: '',
                    version: '',
                    name: '',
                    description: '',
                    parameters: [],
                  },
                  paramGroups: [],
                  nestedStepGroup: null,
                  failbackStepGroup: null,
                  associatedMainNodeId: 1744741562483,
                },
              ],
            },
            stepIndex: 1,
            associatedMainNodeId: 1_744_741_562_483,
            paramGroups: [
              {
                groupTitle: null,
                groupCondition: null,
                parameters: [
                  {
                    parameter: {
                      type: 'BOOLEAN',
                      value: null,
                      id: 5858,
                      textId: 'skipContent',
                      name: 'Content is not needed',
                      required: false,
                      default: 'false',
                      dependsId: null,
                      dependsValue: null,
                      dynamicValues: false,
                      tooltip: null,
                      defaultText: null,
                    },
                    value: null,
                  },
                  {
                    parameter: {
                      type: 'BOOLEAN',
                      value: null,
                      id: 5859,
                      textId: 'failIfOneFailed',
                      name: 'Fail if one failed',
                      required: false,
                      default: 'false',
                      dependsId: null,
                      dependsValue: null,
                      dynamicValues: false,
                      tooltip: null,
                      defaultText: null,
                    },
                    value: null,
                  },
                ],
              },
            ],
            nestGroupId: [],
          },
          {
            stepId: DROPZONE_TYPES.PARALLEL,
            workflowStepGroupId: null,
            module: {
              id: null,
              textId: '',
              version: '',
              name: '',
              description: '',
              parameters: [],
            },
            workflowStepId: 1744741566420,
            nestedStepGroup: null,
            stepTitle: 'Parallel',
            associatedMainNodeId: 1744741562483,
            stepIndex: null,
            failbackStepGroup: null,
            paramGroups: [],
            nestGroupId: [],
          },
        ],
        workflowStepGroupId: null,
      },
      parentWorkflowStepGroupId: null,
      steps: [
        {
          module: {
            id: null,
            textId: '',
            name: '',
            version: '',
            description: '',
            parameters: [],
          },
          nestedStepGroup: null,
          stepId: DROPZONE_TYPES.PREDECESSOR,
          associatedMainNodeId: 1744741562483,
          workflowStepGroupId: null,
          failbackStepGroup: null,
          workflowStepId: 1744741560324,
          nestGroupId: ['1744741562483'],
          stepTitle: 'Predecessor',
          paramGroups: [],
          stepIndex: null,
        },
      ],
      workflowStepGroupId: null,
    },
  },
};

export const WORKFLOW_MOCK_FROM_FAILBACK_MODULE: IDropZoneWorkflowState = {
  steps: [
    {
      endTime: '',
      executionNumber: 0,
      ec2Instance: null,
      jobId: -1,
      jobStepId: -1,
      jobStepParams: [],
      sqsQueueName: '',
      startTime: '',
      status: '',
      submitTime: '',
      workflowStepId: '2',
    },
  ],
  workflow: {
    failbackStepGroup: null,
    name: '',
    nextStepGroup: {
      nextStepGroup: {
        nextStepGroup: {
          parentWorkflowStepGroupId: null,
          nextStepGroup: null,
          workflowStepGroupId: null,
          steps: [
            {
              workflowStepGroupId: null,
              workflowStepId: 1746034193222,
              stepId: '1',
              stepTitle: 'Succeeding',
              module: {
                id: null,
                textId: '',
                version: '',
                name: '',
                description: '',
                parameters: [],
              },
              stepIndex: null,
              nestedStepGroup: null,
              paramGroups: [],
              associatedMainNodeId: 1746034194344,
              failbackStepGroup: null,
              nestGroupId: ['1746034194344'],
            },
          ],
        },
        parentWorkflowStepGroupId: null,
        steps: [
          {
            stepId: '1iq3ruift0b175731bb4b0f',
            workflowStepGroupId: null,
            module: {
              id: 303,
              textId: 'system-noop',
              version: '',
              name: 'System Noop',
              description: 'Do nothing.',
              parameters: [],
            },
            workflowStepId: 1746034194344,
            nestedStepGroup: null,
            stepTitle: 'System Noop',
            failbackStepGroup: {
              parentWorkflowStepGroupId: null,
              workflowStepGroupId: null,
              nextStepGroup: {
                workflowStepGroupId: null,
                parentWorkflowStepGroupId: null,
                steps: [
                  {
                    workflowStepId: 1746034189947,
                    workflowStepGroupId: 1746034189947,
                    stepTitle: 'System Splitter',
                    stepId: '1iq3ruift0b175731bb4b0f',
                    stepIndex: 2,
                    module: {
                      id: 301,
                      textId: 'system-splitter',
                      version: '',
                      name: 'System Splitter',
                      description: 'Split into batches.',
                      parameters: [],
                    },
                    paramGroups: [
                      {
                        groupTitle: null,
                        groupCondition: null,
                        parameters: [
                          {
                            parameter: {
                              type: 'INTEGER',
                              value: null,
                              id: 5287,
                              textId: 'maxNumberOfFiles',
                              name: 'Max number of files',
                              required: true,
                              default: '10',
                              dependsId: null,
                              dependsValue: null,
                              dynamicValues: false,
                              tooltip: null,
                              defaultText: null,
                            },
                            value: null,
                          },
                          {
                            parameter: {
                              type: 'INTEGER',
                              value: null,
                              id: 5288,
                              textId: 'maxSizeInBytes',
                              name: 'Max size in bytes',
                              required: true,
                              default: '1048576',
                              dependsId: null,
                              dependsValue: null,
                              dynamicValues: false,
                              tooltip: null,
                              defaultText: null,
                            },
                            value: null,
                          },
                          {
                            parameter: {
                              type: 'ENUM',
                              valueAsArray: ['Unstructured', 'PCI-NG'],
                              value: 'Unstructured',
                              id: 5289,
                              textId: 'contentType',
                              name: 'Content type',
                              required: true,
                              default: 'Unstructured',
                              dependsId: null,
                              dependsValue: null,
                              dynamicValues: false,
                              tooltip: null,
                              defaultText: null,
                              values: ['Unstructured', 'PCI-NG'],
                            },
                            value: 'Unstructured',
                          },
                        ],
                      },
                    ],
                    nestedStepGroup: null,
                    failbackStepGroup: null,
                    nestGroupId: ['1746034189947'],
                  },
                  {
                    workflowStepId: 1746034198240,
                    workflowStepGroupId: 1746034189947,
                    stepTitle: 'Parallel Failback',
                    stepId: '7',
                    stepIndex: null,
                    module: {
                      id: null,
                      textId: '',
                      version: '',
                      name: '',
                      description: '',
                      parameters: [],
                    },
                    paramGroups: [],
                    nestedStepGroup: null,
                    failbackStepGroup: null,
                    nestGroupId: ['1746034189947'],
                  },
                ],
                nextStepGroup: {
                  workflowStepGroupId: null,
                  parentWorkflowStepGroupId: null,
                  steps: [
                    {
                      workflowStepId: 1746034198793,
                      workflowStepGroupId: 1746034189947,
                      stepTitle: 'Succeeding Failback',
                      stepId: '6',
                      stepIndex: null,
                      module: {
                        id: null,
                        textId: '',
                        version: '',
                        name: '',
                        description: '',
                        parameters: [],
                      },
                      paramGroups: [],
                      nestedStepGroup: null,
                      failbackStepGroup: null,
                      associatedMainNodeId: 1746034189947,
                      nestGroupId: ['1746034189947', '1746034189947'],
                    },
                  ],
                  nextStepGroup: null,
                },
              },
              steps: [
                {
                  workflowStepId: 1746034192235,
                  workflowStepGroupId: 1746034189947,
                  stepTitle: 'Predecessor',
                  stepId: '0',
                  stepIndex: null,
                  module: {
                    id: null,
                    textId: '',
                    version: '',
                    name: '',
                    description: '',
                    parameters: [],
                  },
                  paramGroups: [],
                  nestedStepGroup: null,
                  failbackStepGroup: null,
                  associatedMainNodeId: 1746034189947,
                  nestGroupId: ['1746034189947', '1746034189947'],
                },
              ],
            },
            stepIndex: 1,
            associatedMainNodeId: 1_746_034_194_344,
            paramGroups: [
              {
                groupTitle: null,
                groupCondition: null,
                parameters: [],
              },
            ],
            nestGroupId: [],
          },
          {
            stepId: '4',
            workflowStepGroupId: null,
            module: {
              id: null,
              textId: '',
              version: '',
              name: '',
              description: '',
              parameters: [],
            },
            workflowStepId: 1746034192210,
            nestedStepGroup: null,
            stepTitle: 'Parallel',
            associatedMainNodeId: 1746034194344,
            stepIndex: null,
            failbackStepGroup: null,
            paramGroups: [],
            nestGroupId: [],
          },
        ],
        workflowStepGroupId: null,
      },
      parentWorkflowStepGroupId: null,
      steps: [
        {
          module: {
            id: null,
            textId: '',
            name: '',
            version: '',
            description: '',
            parameters: [],
          },
          nestedStepGroup: null,
          stepId: '0',
          associatedMainNodeId: 1746034194344,
          workflowStepGroupId: null,
          failbackStepGroup: null,
          workflowStepId: 1746034190980,
          nestGroupId: ['1746034194344'],
          stepTitle: 'Predecessor',
          paramGroups: [],
          stepIndex: null,
        },
      ],
      workflowStepGroupId: null,
    },
  },
};

// Default initial nodes positions and constants
export const DROPZONES_X_OFFSET = 200;
export const LEGEND_MARGIN = 300;
export const FAILBACK_NODE_MARGIN = 66;
export const FAILBACK_LABEL_MARGIN = 96;
export const LEGEND_NODE_X_MARGIN = 235;
export const UPDATE_POSITION_DELAY = 300;
export const DEFAULT_CONTAINER_WIDTH = 1000;

export const generateDefaultNodes = (
  currentNodes: FlowNode[],
  containerWidth: number,
  isDefaultLayout: boolean
) => {
  return currentNodes.map((node) => {
    if (node.id === DEFAULT_NODES_IDS.LEGEND_NODE) {
      const maxNodeX = currentNodes
        .filter((n) => n.id !== DEFAULT_NODES_IDS.LEGEND_NODE)
        .reduce((max, n) => Math.max(max, n.position.x), 0);

      const legendX = Math.max(
        maxNodeX + LEGEND_MARGIN,
        containerWidth - LEGEND_NODE_X_MARGIN
      );

      return {
        ...node,
        position: {
          x: legendX,
          y: 20,
        },
      };
    }

    if (node.id === DEFAULT_NODES_IDS.INITIAL_DROPZONE) {
      return {
        ...node,
        position: {
          x: containerWidth / 2 - DROPZONES_X_OFFSET,
          y: node.position.y,
        },
      };
    }

    if (
      node.id === DEFAULT_NODES_IDS.INITIAL_FAILBACK_DROPZONE &&
      isDefaultLayout
    ) {
      return {
        ...node,
        position: {
          x: containerWidth / 2 - DROPZONES_X_OFFSET,
          y: node.position.y,
        },
      };
    }

    if (
      (node.id === DEFAULT_NODES_IDS.ORCHESTRATION_STEPS ||
        node.id === DEFAULT_NODES_IDS.GLOBAL_FAILBACK_STEPS) &&
      isDefaultLayout
    ) {
      return {
        ...node,
        position: {
          x: node.position.x,
          y: node.position.y,
        },
      };
    }
    return node;
  });
};
